import React from 'react';
import { Field } from 'redux-form';
import { M } from '@dashboard-experience/mastodon';
import PropTypes from 'prop-types';
import * as V from 'lib/validations';
import { getFieldKey } from 'utils';
import DatePicker from 'components/fields/mastodon/DatePicker';
import { bestAvailableDisplayText } from './helpers';

function MatrixDateFieldContainer({ field }) {
  if (!field) return null;

  const fieldKey = getFieldKey(field);

  return (
    <M.Container>
      <M.Grid>
        <M.Container.Row>
          <M.Container.Col
            className='form-group-col matrix-label-style'
            sm={4}
            md={4}
            lg={8}
          >
            <Field
              type='text'
              testId={fieldKey}
              name={fieldKey}
              datePickerType='single'
              component={DatePicker}
              validate={[V.required, V.datePickerValidation]}
              placeholder={bestAvailableDisplayText(field, 'placeholder')}
              labelControl={bestAvailableDisplayText(field, 'displayTitle')}
            />
          </M.Container.Col>
        </M.Container.Row>
      </M.Grid>
    </M.Container>
  );
}

MatrixDateFieldContainer.propTypes = {
  field: PropTypes.object,
};

MatrixDateFieldContainer.defaultProps = {
  field: null,
};

export default MatrixDateFieldContainer;
